import { CMSPageTypeValues } from '@/src/cms/domain/types/cms-page.types';
import { useSsrData } from '@/src/shared/presentation/providers/ssr-data-provider';

import { CmsContentForPathSSRFactory } from '../ssr/cms-content-for-path-ssr-factory';

import { cmsPageViewsMap } from './cms-page-views-map';

import type { CMSPageContentViewModel } from '../types/cms-content.viewModel';


export function DynamicCMSPageView() {
  const content = useSsrData<CMSPageContentViewModel>(CmsContentForPathSSRFactory.getKey());
  const PageComponent = CMSPageTypeValues.includes(content.$type)
    ? cmsPageViewsMap[content.$type]
    : () => null;

  // FIXME
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return <PageComponent content={content as any} />;
}
